define('home/mixins/asModal',[
    'underscore',

    'home/utils/confirmModal',
], function (
    _,

    confirmModal
) {
    'use strict';

    var asModalView = {

        initialize: function (_initialize, options) {
            _initialize.apply(this, _.rest(arguments));
            this.modal = this.getModal(options);
        },

        onRender: function (_onRender) {
            if (_onRender)
                _onRender.apply(this, _.rest(arguments));
            this.modal.find('[data-role=content]').append(this.$el);
        },

        showModal: function (modalOptions) {
            if (modalOptions)
                this.modal.modal(modalOptions);

            this.modal.modal('show');
        },

        closeModal: function () {
            this.remove();
            this.modal.modal('hide');
        },
    };

    var asModal = function (modalOptions) {
        this.initialize = _.wrap(this.initialize, asModalView.initialize);
        this.onRender = _.wrap(this.onRender, asModalView.onRender);
        this.getModal = confirmModal.getModal;
        this.showModal = _.partial(asModalView.showModal, modalOptions);
        this.closeModal = asModalView.closeModal;
    };

    return asModal;
});


